import type { SearchPagination, SearchResponse } from '@algolia/client-search';

import type { AppConfig } from '#/config/types/AppConfig';
import type { SearchAlgoliaHit } from '#/modules/search/algolia/types/SearchAlgoliaHit';
import { algoliaTrackClick } from '#/utils/algolia/algoliaTrackClick';
import { trackClicked } from '#/utils/analytics/track/trackClicked';

type Args = {
  results: SearchResponse<SearchAlgoliaHit> & Required<SearchPagination>;
  hit: SearchAlgoliaHit;
  index: number;
  trackingData: Record<string, unknown>;
  appConfig: AppConfig;
};

export function trackSearchResultHitClick({
  results,
  hit,
  index,
  trackingData,
  appConfig,
}: Args) {
  const { hitsPerPage, page, queryID } = results;

  // Skip tracking Algolia click for promoted listing
  if (index !== -1) {
    void algoliaTrackClick({
      queryID,
      objectID: hit.objectID, // Position in algolia analytics is 1-indexed
      position: hitsPerPage ? page * hitsPerPage + index + 1 : index + 1,
      appConfig,
    });
  }

  trackClicked('Search Result', {
    org_id: 'orgID' in hit ? hit.orgID : undefined,
    org_type: 'orgType' in hit ? hit.orgType : undefined,
    result_id: hit.objectID,
    result_index: index,
    result_type: hit.type,
    ...(hit.type === 'VOLOP' || hit.type === 'IMPORTED'
      ? {
          result_source: 'source' in hit ? hit.source : 'IDEALIST',
          action_type: 'VOLOP',
        }
      : {}),
    ...trackingData,
  });
}
